import CoordinateChallenge from './CoordinateChallenge';

export default CoordinateChallenge; 